module.exports = __webpack_public_path__ + "img/Suldeste.118a5a3b.svg";